import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { InOtherCartsCardData } from '../rql';
import cartNudgeIcon from '@reverbdotcom/cadence/images/nudge/cart-nudge.svg';

interface IProps {
  listing: InOtherCartsCardData.Fragment;
}

export const InOtherCartsCardFragment = gql`
  fragment InOtherCartsCardData on Listing {
    _id
    id
    otherBuyersWithListingInCartCounts
  }
`;

export function InOtherCartsCardNudge(props: IProps) {
  const { otherBuyersWithListingInCartCounts } = props.listing;
  const eligible = !!otherBuyersWithListingInCartCounts &&
    otherBuyersWithListingInCartCounts > 0;

  if (!eligible) { return null; }

  return (
    <div className="listing-card-nudge">
      <img src={cartNudgeIcon} alt="InOtherCartsNudge" />
      {I18n.t(
        'commons.listingNudge.inOtherCarts',
        { count: otherBuyersWithListingInCartCounts },
      )}
    </div>
  );
}
